// src/icons/DeleteIcon.tsx
import { useTheme } from "@emotion/react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function DeleteIcon({
  strokeWidth = "1.33333",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "16", height: "16", rx: "8", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5.3335 5.33337L10.6668 10.6667",
            stroke: theme.bg,
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5.3335 10.6666L10.6668 5.33329",
            stroke: theme.bg,
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  DeleteIcon
};
